import React, { useCallback, useEffect, useState } from "react";
import { getMyConsultationReviews } from "../../Services/ConsultationReviewService";
import ReviewDetails from "./ReviewDetails";

const MyConsultationReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const load = useCallback(async () => {
    setLoading(true);
    setError(false);
    try { setReviews(await getMyConsultationReviews()); }
    catch { setError(true); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);
  return <section className="review-section iran-sans" dir="rtl" aria-labelledby="my-reviews-title">
    <h3 id="my-reviews-title">نظرات من درباره پزشک</h3>
    {loading ? <p className="review-muted" role="status">در حال دریافت نظرات…</p> : error ? <p className="review-feedback" role="alert">دریافت نظرات ممکن نشد. <button type="button" className="review-button review-button--quiet" onClick={load}>تلاش دوباره</button></p> : reviews.length === 0 ? <p className="review-muted">هنوز نظری درباره پزشک ثبت نکرده‌اید. از صفحه اصلی یا تاریخچه مشاوره‌ها می‌توانید نظر بدهید.</p> : <div className="review-list">{reviews.map((review) => <div key={review.id} className="review-list-item"><ReviewDetails review={review} /></div>)}</div>}
  </section>;
};

export default MyConsultationReviews;
